"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('oval-love-two', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M18.258 17.5001C12.7352 27.066 13.2985 37.7308 19.5163 41.3206C20.8461 42.0884 22.3269 42.4704 23.8872 42.5029C29.6225 42.6223 36.433 38.0201 40.7747 30.5001C46.2975 20.9343 45.7341 10.2695 39.5163 6.67962C35.1001 4.12989 29.0191 5.83505 23.8872 10.4647C21.7937 12.3533 19.8582 14.7285 18.258 17.5001Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M8.25809 6.67962C2.04029 10.2695 1.47691 20.9343 6.99976 30.5001C11.3414 38.0201 18.1519 42.6223 23.8872 42.5029C22.3269 42.4704 20.8461 42.0884 19.5163 41.3206C13.2985 37.7308 12.7352 27.066 18.258 17.5001C19.8582 14.7285 21.7937 12.3533 23.8872 10.4647C18.7553 5.83505 12.6744 4.12989 8.25809 6.67962Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M23.8872 10.4647C29.0191 5.83505 35.1001 4.12989 39.5163 6.67962C45.7341 10.2695 46.2975 20.9343 40.7747 30.5001C36.433 38.0201 29.6225 42.6223 23.8872 42.5029M23.8872 10.4647C21.7937 12.3533 19.8582 14.7285 18.258 17.5001C12.7352 27.066 13.2985 37.7308 19.5163 41.3206C20.8461 42.0884 22.3269 42.4704 23.8872 42.5029M23.8872 10.4647C18.7553 5.83505 12.6744 4.12989 8.25809 6.67962C2.04029 10.2695 1.47691 20.9343 6.99976 30.5001C11.3414 38.0201 18.1519 42.6223 23.8872 42.5029",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;